/*!
 * Copyright © 2019-2022. Verizon Connect Ireland Limited. All rights reserved.
 */

import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyProgressBarModule } from '@angular/material/legacy-progress-bar';
import { MatLegacySelectModule } from '@angular/material/legacy-select';
import { TooltipModule } from 'shared';
import { FmSearchLightModule } from '../searchlight';
import {
  CloseIconButtonComponent,
  CloseStreetViewComponent,
  DateAgoDisplayComponent,
  EvBatteryRangeSectionComponent,
  EvBatterySectionComponent,
  FitToMapComponent,
  GhostElementComponent,
  GhostElementLoaderImageComponent,
  IconLegendItemComponent,
  MapOptionSectionComponent,
  MapTypeSwitcherComponent,
  MapTypeSwitcherControlComponent,
  SpeedViolationComponent,
  StatusFilterOptionsComponent,
  StatusSortOptionsComponent
} from './components';
import { HealthStatusTooltipComponent } from './components/health-status-tooltip/health-status-tooltip.component';
import { ResizeColumnDirective } from './directives';
import {
  DeviceHealthCategoryLocalizePipe,
  DeviceHealthErrorLocalizePipe,
  DeviceHealthIssueTooltip,
  ObjectFieldSortPipe,
  SpeedConvertPipe,
  SpeedRangeConvertPipe,
  SpeedUnitsPipe
} from './pipes';

@NgModule({
  imports: [
    CommonModule,
    ScrollingModule,
    MatCheckboxModule,
    MatIconModule,
    TooltipModule,
    FormsModule,
    ReactiveFormsModule,
    MatLegacySelectModule,
    MatLegacyProgressBarModule,
    DeviceHealthCategoryLocalizePipe,
    DeviceHealthErrorLocalizePipe,
    DeviceHealthIssueTooltip
  ],
  declarations: [
    SpeedViolationComponent,
    MapTypeSwitcherControlComponent,
    CloseStreetViewComponent,
    CloseIconButtonComponent,
    SpeedUnitsPipe,
    SpeedConvertPipe,
    SpeedRangeConvertPipe,
    FitToMapComponent,
    MapOptionSectionComponent,
    MapTypeSwitcherComponent,
    IconLegendItemComponent,
    GhostElementComponent,
    ObjectFieldSortPipe,
    GhostElementLoaderImageComponent,
    StatusFilterOptionsComponent,
    StatusSortOptionsComponent,
    ResizeColumnDirective,
    EvBatterySectionComponent,
    EvBatteryRangeSectionComponent,
    DateAgoDisplayComponent,
    HealthStatusTooltipComponent
  ],
  exports: [
    SpeedViolationComponent,
    MapTypeSwitcherControlComponent,
    CloseStreetViewComponent,
    CloseIconButtonComponent,
    SpeedUnitsPipe,
    SpeedConvertPipe,
    SpeedRangeConvertPipe,
    FitToMapComponent,
    MapOptionSectionComponent,
    MapTypeSwitcherComponent,
    IconLegendItemComponent,
    GhostElementComponent,
    FmSearchLightModule,
    ObjectFieldSortPipe,
    GhostElementLoaderImageComponent,
    StatusFilterOptionsComponent,
    StatusSortOptionsComponent,
    ResizeColumnDirective,
    EvBatterySectionComponent,
    EvBatteryRangeSectionComponent,
    DateAgoDisplayComponent,
    HealthStatusTooltipComponent
  ]
})
export class SharedModule {}
